import axios from "@/plugins/axios/researchApi";

export default {
  GET_ADS: async ({ commit, getters }) => {
    commit("SET_ERROR", false);
    commit("SET_LOADER", true);
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getters.getToken,
        user: getters.getCurrentUser?.userId ?? "",
      },
    };
    return new Promise((resolve, reject) => {
      axios
        .get("ads/allAds", config)
        .then((res) => {
          commit("SET_LOADER", false);
          resolve(res.data.ads || res.data.advertisements || []);
          console.log(res);
        })
        .catch((err) => {
          reject(err);
          commit("SET_LOADER", false);
          commit("SET_ERROR", true);
          commit("SNACKBAR", {
            snackbar: true,
            message:
              err.response?.data?.message || "Failed to load advertisements",
            type: "error",
          });
        });
    });
  },

  SINGLE_AD: async ({ commit, getters }, payload) => {
    commit("SET_ERROR", false);
    commit("SET_LOADER", true);
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getters.getToken,
        user: getters.getCurrentUser?.userId ?? "",
      },
    };
    return new Promise((resolve, reject) => {
      axios
        .get(`ads/singleAds/${payload}`, config)
        .then((res) => {
          commit("SET_LOADER", false);
          resolve(res.data.ad || res.data.advertisement);
        })
        .catch((err) => {
          reject(err);
          commit("SET_LOADER", false);
          commit("SET_ERROR", true);
          commit("SNACKBAR", {
            snackbar: true,
            message:
              err.response?.data?.message || "Failed to load advertisement",
            type: "error",
          });
        });
    });
  },

  CREATE_AD: async ({ commit, getters }, payload) => {
    commit("SET_ERROR", false);
    commit("SET_LOADER", true);
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getters.getToken,
      },
    };
    try {
      let response = await axios.post("ads/createAds", payload, config);
      commit("SET_LOADER", false);
      commit("SNACKBAR", {
        snackbar: true,
        message: response.data.message || "Advertisement created successfully",
        type: "success",
      });
      return response.data;
    } catch (error) {
      commit("SET_LOADER", false);
      commit("SET_ERROR", true);
      commit("SNACKBAR", {
        snackbar: true,
        message:
          error.response?.data?.message || "Failed to create advertisement",
        type: "error",
      });
      console.log(error);
      throw error;
    }
  },

  UPDATE_AD: async ({ commit, getters }, payload) => {
    commit("SET_ERROR", false);
    commit("SET_LOADER", true);
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getters.getToken,
      },
    };
    try {
      let response = await axios.put(
        `ads/updateAds/${payload.id}`,
        payload,
        config
      );
      commit("SET_LOADER", false);
      commit("SNACKBAR", {
        snackbar: true,
        message: response.data.message || "Advertisement updated successfully",
        type: "success",
      });
      console.log(response);
      return response.data;
    } catch (error) {
      commit("SET_LOADER", false);
      commit("SET_ERROR", true);
      commit("SNACKBAR", {
        snackbar: true,
        message:
          error.response?.data?.message || "Failed to update advertisement",
        type: "error",
      });
      console.log(error);
      throw error;
    }
  },

  DELETE_AD: async ({ commit, getters }, payload) => {
    commit("SET_ERROR", false);
    commit("SET_LOADER", true);
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getters.getToken,
      },
    };
    try {
      let response = await axios.delete(
        `ads/deleteAds/${payload.id}`,
        config
      );
      commit("SET_LOADER", false);
      commit("SNACKBAR", {
        snackbar: true,
        message: response.data.message || "Advertisement deleted successfully",
        type: "success",
      });
      console.log(response);
      return response.data;
    } catch (error) {
      commit("SET_LOADER", false);
      commit("SET_ERROR", true);
      commit("SNACKBAR", {
        snackbar: true,
        message:
          error.response?.data?.message || "Failed to delete advertisement",
        type: "error",
      });
      console.log(error);
      throw error;
    }
  },

  EXTEND_AD: async ({ commit, getters }, payload) => {
    commit("SET_ERROR", false);
    commit("SET_LOADER", true);
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getters.getToken,
      },
    };
    try {
      let response = await axios.put(
        `ads/extendAds/${payload.id}`,
        payload,
        config
      );
      commit("SET_LOADER", false);
      commit("SNACKBAR", {
        snackbar: true,
        message: response.data.message || "Advertisement extended successfully",
        type: "success",
      });
      console.log(response);
      return response.data;
    } catch (error) {
      commit("SET_LOADER", false);
      commit("SET_ERROR", true);
      commit("SNACKBAR", {
        snackbar: true,
        message:
          error.response?.data?.message || "Failed to extend advertisement",
        type: "error",
      });
      console.log(error);
      throw error;
    }
  },
};
